import { useEffect } from 'react';
import { useBrand } from '../hooks/useBrand';
import { CSS_VARIABLES } from '../config/brands';

/**
 * ThemeProvider component that applies brand-specific CSS custom properties
 * to the document root element dynamically based on the current brand
 */
export function ThemeProvider({ children }) {
  const brand = useBrand();

  useEffect(() => {
    const root = document.documentElement;

    // Apply each CSS variable mapping
    Object.entries(CSS_VARIABLES).forEach(([cssVar, colorKey]) => {
      let value;

      // Handle font separately (not in colors object)
      if (colorKey === 'font') {
        value = brand.font;
      } else {
        value = brand.colors[colorKey];
      }

      if (value) {
        root.style.setProperty(cssVar, value);
      }
    });

    // Add brand-specific class to body for brand-specific CSS overrides
    const body = document.body;
    // Remove any existing brand classes
    body.classList.remove('brand-claims1', 'brand-ycm', 'brand-mlm');
    // Add current brand class
    const brandClass = `brand-${brand.id.toLowerCase()}`;
    body.classList.add(brandClass);
  }, [brand]);

  return children;
}
